<template>
  <div class="work-header">

    <div class="div1">
      <div>
        <p class="d-f">
          <span class="title">Year</span>
          <span class="slot">
            <slot name="year"></slot>
          </span>
        </p>
        <br>
        <p class="d-f">
          <span class="title">Client</span>
          <span class="slot">
            <slot name="client"></slot>
          </span>
        </p>
        <br>
        <p class="d-f">
          <span class="title">Delivery</span>
          <span class="slot">
            <slot name="type"></slot>
          </span>
        </p>
        <br>
        <p class="d-f">
          <span class="title">Links</span>
          <span class="slot">
            <slot name="website"></slot>
          </span>
        </p>
        <br>
      </div>
    </div>

    <div class="div2"></div>
    <div class="div3"></div>

    <div class="div4">
      <p class="desc">
        <slot name="desc"></slot>
      </p>
    </div>

  </div>
</template>

<script>

export default {
  name: 'WorkHeader',
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/_vars.scss";
@import "@/scss/_mixins.scss";
@import "@/scss/_classes.scss";

</style>
